// extracted by mini-css-extract-plugin
module.exports = {"progress":"PercentageBar-module_progress_xhIgc","bar":"PercentageBar-module_bar_39gdz","divider":"PercentageBar-module_divider_QP1LH"};